import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import PropTypes from "prop-types";
import { TC } from "../../tokens/text";

const SIZE_MAP = { sm: 20, md: 28, lg: 44 };

function LoadingSpinner({ size, label, centered, color }) {
  const px = SIZE_MAP[size] || SIZE_MAP.md;

  const spinner = (
    <VuiBox
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
      display="inline-flex"
    >
      <CircularProgress
        size={px}
        thickness={4}
        sx={{
          color,
          filter: `drop-shadow(0 0 6px ${color}88)`,
        }}
      />
    </VuiBox>
  );

  if (!centered && !label) return spinner;

  return (
    <VuiBox
      display="flex"
      flexDirection={label ? "column" : "row"}
      alignItems="center"
      justifyContent="center"
      gap={1}
      py={centered ? 2 : 0}
    >
      {spinner}
      {label && (
        <VuiTypography
          variant="caption"
          sx={{ color: TC.secondary, fontSize: 13, mt: 0.5 }}
        >
          {label}
        </VuiTypography>
      )}
    </VuiBox>
  );
}

LoadingSpinner.defaultProps = {
  size: "md",
  label: "",
  centered: true,
  color: TC.linkHover,
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  label: PropTypes.string,
  centered: PropTypes.bool,
  color: PropTypes.string,
};

export default LoadingSpinner;

